import { render, staticRenderFns } from "./ItemFormSection.vue?vue&type=template&id=382c8dd6&scoped=true&"
import script from "./ItemFormSection.vue?vue&type=script&lang=js&"
export * from "./ItemFormSection.vue?vue&type=script&lang=js&"
import style0 from "./ItemFormSection.vue?vue&type=style&index=0&id=382c8dd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382c8dd6",
  null
  
)

export default component.exports